import { type Store } from "@reduxjs/toolkit";
import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from "react-redux";

import { type RootState, type AppDispatch } from "./store";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Allows routes to wait for state to become available before loading the render
// component
export function waitForState(
  store: Store,
  predicate: (state: RootState) => boolean,
  timeout = 500,
) {
  if (predicate(store.getState())) {
    return Promise.resolve(true);
  }

  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      unsubscribe();
      reject(new Error("Timeout waiting for state update"));
    }, timeout);

    const unsubscribe = store.subscribe(() => {
      if (predicate(store.getState())) {
        clearTimeout(timeoutId);
        unsubscribe();
        resolve(true);
      }
    });
  });
}
